import React, { useState, useEffect, useCallback } from "react";
import LabelText from "../../../ui/LabelText";
import { useClubSearch } from "../../../contexts/ClubSearchContext";
import CloseIcon from "@mui/icons-material/Close";
import { ForawrdBackwardButton } from "../../../styled-components/PageHeaderStyles";
import { useSidebar } from "../../../contexts/SidebarContext";
import { IPlayerSearchResponse } from "../../../types/IPlayerSearchResponse";
import { fetchData, postData } from "../../../services/api";
import handleApiResponse from "../../../utils/handleApiResponse";
import IApiResponse from "../../../types/IApiResponse";
import apiUrls from "../../../config/apiUrls";
import { styled } from "styled-components";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../../contexts/LoadingContext";
import ClubSearchList from "./ClubSearchList";
import { IClubList, IseasonData, ITeamArchtypeInfo } from "../../../types/IClubDetail";
import BarChart from "../../PlayerLanding/PlayerSearch/BarChart";
import FilteredDropdown from "../../../ui/FilterDropdown";
import { useTheme } from "../../../contexts/ThemeContext";
import PrimaryButton from "../../../ui/PrimaryButton";
import { IClubFilterOptions } from "../../../types/IClubSearch";
import { debounceFunction } from "../../../utils/debounceFunction";
import SearchInput from "../../../ui/SearchInput";
import { Drawer } from "@mui/material";
import { ModuleSpinner } from "../../../ui/LoadingSpinner/ModuleSpinner";
import StandardDropdown from "../../../ui/StandardDropdown/StandardDropdown";
import { filterWomensFootball } from "../../../utils/womensFootballFilter";


const SearchResults = styled.div`
  background: ${({ theme }) => theme.searchResultsFooterBackground};
  backdrop-filter: blur(32px);
  -webkit-backdrop-filter: blur(32px);
`;

const DrawerContainer = styled.div`
  background: ${({ theme }) => theme.playerContentBackground};
`;

interface SelectedOption {
  region: string;
  optionId: number;
}
interface IClubInitialSearchProps{
  open: boolean;
  setIsOpen: (open:boolean) => void;
  archtypeId: number;
  isFromSimulation?: boolean;
  teamId?: number;
  handleSeasonChange?: (value : string) => void;
  seasonData?: any[];
  seasonLabel?: string;
  handleConfirm?: () => void;
}

const ClubInitialSearch:React.FC<IClubInitialSearchProps> = ({open , setIsOpen , archtypeId , isFromSimulation , teamId , handleSeasonChange , seasonData , seasonLabel , handleConfirm}) => {

  const theme = useTheme();
  const navigate = useNavigate();
  const { loading, startLoading, stopLoading } = useLoading();
  const { toggleSidebar, toggleDrawer } = useSidebar();
  const {
    clubSearchData,
    clubSearchText,
    setClubSearchData,
    setClubSearchText,
  } = useClubSearch();

  const [selectedItems, setSelectedItems] = useState<IPlayerSearchResponse[]>([]);
  const [clearInput, setClearInput] = useState(false);
  const [moduleLoading, setModuleLoading] = useState<boolean>(false);
  const [teamArchtypeInfo, setTeamArchTypeInfo] = useState<ITeamArchtypeInfo[]>([]);
  const [searchItemsFromStorage, setSearchItemsFromStorage] = useState<number[]>(JSON.parse(localStorage.getItem("ClubSearchItem")!)?.reverse());

  const handleSearch = useCallback(
    debounceFunction(async (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      if (value.length >= 3) {
        setClubSearchText(value);
        setModuleLoading(true);
        try {
           const response: IApiResponse<IClubList[]> = await fetchData(`${apiUrls["GetTeamsByFreeTextSearch"]}?searchString=${value}`);
          handleApiResponse(
            response,
            (clubSearchData) => {
              setModuleLoading(false);
              setClubSearchData?.(filterWomensFootball(clubSearchData));
            },

            (error) => {
              setModuleLoading(false);
              console.error("Error fetching Player Search Data:", error);
            }
          );
        } catch (error) {
          setModuleLoading(false);
           console.error("Error fetching Player Search Data:", error);
        }
      } else {
        setModuleLoading(false);
        setClubSearchData?.([]);
      }
    }, 1000),
    []
  );

  const handleClear = () => {
    setClubSearchText("");
    setClubSearchData?.([]);
  };

  const handleSelect = (item: IPlayerSearchResponse | IPlayerSearchResponse[] | null, selected: boolean) => {};

  const renderSearchClubs = () => {
    return (
      clubSearchData &&
      clubSearchData?.length > 0 && (
        <div className="player-profile-list padding-bottom" style={{height:"200px"}}>
          <ClubSearchList
            searchData={clubSearchData}
            searchText={clubSearchText}
            onSelect={handleSelect}
            selectedItems={selectedItems}
            multiSelection={false} //isAdding
            iconType="image"
            displayCheckBox={false}
            isForCompareTeamASrchtype={true}
          />
        </div>
      )
    );
  };

  useEffect(()=>{
    // debugger
    const fetchArchetypeInfoData = async () => {
      try {
        setModuleLoading(true);
        const response: IApiResponse<ITeamArchtypeInfo[]> = await fetchData(
          `${apiUrls["GetTeamArchetypeDetails"]}/${archtypeId}`
        );
        if (response.isSuccess) {
          setModuleLoading(false);
          setTeamArchTypeInfo(filterWomensFootball(response.data || []));
          return response;
        }

      } catch (error) {
        setModuleLoading(false);
        return console.log(
          "500",
          "API call failed due to an internal server error"
        );
      }
    };
    if(archtypeId){
      fetchArchetypeInfoData();
    }
  },[archtypeId])

  const handleClose = () =>{
    setIsOpen(!open)
    setClubSearchText("");
    setClubSearchData?.([]);
  }

    const clearPreviousSearches = () => {
      localStorage?.removeItem("ClubSearchItem");
      setSearchItemsFromStorage([]);
    };

  return (
      <Drawer
          PaperProps={{
            style: {
              left: "70px",
              backgroundColor: "#F9FAF7",
              backdropFilter: "blur(16px)",
              width: "520px",
              zIndex: "99999",
            },
          }}
          anchor="left"
          variant="persistent"
          open={open}
          onClose={handleClose}
      >
          <DrawerContainer className="main-drawer-container">
              <div className="drawer-header">
                <LabelText className="drawer-title">Comparison team</LabelText>
                <div className="header-buttons">
                  <ForawrdBackwardButton onClick={handleClose}>
                    <CloseIcon className="cta-btn-icons" />
                  </ForawrdBackwardButton>
                </div>
              </div>
               
              <div className="player-search-data">
                <div className="container active">
                  <SearchInput
                    handleSearch={handleSearch}
                    handleClear={handleClear}
                    placeholder="Search clubs"
                    fontSize="32px"
                    type="SearchPlayer"
                    clearInput={clearInput}
                    autoFocus={false}
                  />
                </div>
                 {isFromSimulation && seasonData?.length! > 0 && (
                    <div className="timeframe">
                      <LabelText className="header-text">Select a season</LabelText>
                      <StandardDropdown
                          placeholder="Select a season"
                          options={seasonData!}
                          isDisplaySearchInput={false}
                          onChange={handleSeasonChange}
                          defaultSelected={seasonLabel}
                          isForClub={true}
                      />
                    </div>
                  )}
                {renderSearchClubs()}
                {moduleLoading && ( <ModuleSpinner/>)}
                <div className="individuas-pitch-player-conatiner">
                    <div className="typical-exmaples-container">
                      <LabelText className="player-search-text">Similar playing style - most successful</LabelText>
                      <div className="individual-typical-player-container">
                      <div className="player-profile-list padding-bottom">
                          <ClubSearchList
                            searchData={teamArchtypeInfo}
                            searchText={""}
                            selectedItems={[]}
                            multiSelection={false}
                            iconType="image"
                            displayCheckBox={false}
                            isForCompareTeamASrchtype={true}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {searchItemsFromStorage?.length > 0 && (
                    <div className="previous-search-container">
                        <div className="previous-search-header">
                          <p>Previous searches</p>
                          <p onClick={() => clearPreviousSearches()}>Clear</p>
                        </div>
                        <div className="player-profile-list padding-bottom">
                          <ClubSearchList
                            searchData={searchItemsFromStorage}
                            searchText={""}
                            selectedItems={[]}
                            multiSelection={false}
                            iconType="image"
                            displayCheckBox={false}
                            isForCompareTeamASrchtype={true}
                          />
                        </div>
                     </div>
                  )}
                 
              </div>
             
            {/* {(region.length > 0 || isFilterChange) && active === "SearchCriteria" && (
              <SearchResults className="search-profile-result">
                <PrimaryButton onClick={handleClubSearchResult} iconType="Search" label="Run Search" />
              </SearchResults>
            )} */}
             <SearchResults className="search-profile-result">
                  <PrimaryButton  iconType="confirm" label="Confirm" onClick={handleConfirm}/>
              </SearchResults>
          </DrawerContainer>
      </Drawer>
  );
};

export default ClubInitialSearch;
